import { createTamagui } from "tamagui";

import { animations } from "./animations";
import { fonts } from "./fonts";
import { mediaQueries } from "./mediaQueries";
import { themes } from "./themes";
import { tokens } from "./tokens";

const config = createTamagui({
  defaultFont: "body",
  animations,
  shouldAddPrefersColorThemes: true,
  themeClassNameOnRoot: true,
  shorthands: {
    p: "padding",
    m: "margin",
    w: "width",
    h: "height",
    bg: "backgroundColor",
    jc: "justifyContent",
    ai: "alignItems",
  },
  fonts,
  themes,
  tokens,
  media: mediaQueries,
});

export default config;
export type AppConfig = typeof config;
